{
  "title": "Psionic Blast (UA)",
  "source": "Unearthed Arcana 66 - Fighter, Rogue, and Wizard",
  "levelAndSchool": "3rd-level evocation",
  "level": 3,
  "castingTime": "1 action",
  "range": "Self (30-foot cone)",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You unleash a destructive wave of mental power in a 30-foot cone. Each creature in the area must make a Dexterity saving throw. On a failed save, a target takes 5d8 force damage, is pushed 20 feet directly away from you, and is knocked prone. On a successful save, a target takes half as much damage and isn’t pushed or knocked prone.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the damage increases by 1d8 for each slot level above 3rd."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "warlock", "wizard"]
}
